"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("@styled-system/prop-types"));

var _tooltip = _interopRequireDefault(require("../tooltip"));

var _tags = _interopRequireDefault(require("../../utils/helpers/tags"));

var _portraitGravatar = _interopRequireDefault(require("./portrait-gravatar.component"));

var _portraitInitials = _interopRequireDefault(require("./portrait-initials.component"));

var _portrait = require("./portrait.style");

var _utils = require("../../style/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const marginPropTypes = (0, _utils.filterStyledSystemMarginProps)(_propTypes2.default.space);

let Portrait = /*#__PURE__*/function (_React$Component) {
  _inherits(Portrait, _React$Component);

  var _super = _createSuper(Portrait);

  function Portrait(...args) {
    var _this;

    _classCallCheck(this, Portrait);

    _this = _super.call(this, ...args);

    _defineProperty(_assertThisInitialized(_this), "state", {
      externalError: false
    });

    return _this;
  }

  _createClass(Portrait, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      const relevantPropsChanged = this.props.gravatar !== prevProps.gravatar || this.props.src !== prevProps.src;

      if (relevantPropsChanged) {
        this.setState({
          externalError: false
        }); // eslint-disable-line react/no-did-update-set-state
      }
    }
  }, {
    key: "getMarginProps",
    value: function getMarginProps() {
      return (0, _utils.filterStyledSystemMarginProps)(this.props);
    }
  }, {
    key: "externalImageLoadFailed",
    value: function externalImageLoadFailed() {
      this.setState({
        externalError: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      const {
        alt,
        darkBackground,
        gravatar,
        iconType,
        initials,
        shape,
        size,
        src,
        onClick,
        tooltipMessage,
        tooltipId,
        tooltipIsVisible,
        tooltipPosition,
        tooltipType,
        tooltipSize,
        tooltipBgColor,
        tooltipFontColor
      } = this.props;
      const tagProps = (0, _tags.default)("portrait", this.props);

      let portrait = /*#__PURE__*/_react.default.createElement(_portrait.StyledIcon, {
        type: iconType,
        size: size,
        shape: shape,
        darkBackground: darkBackground
      });

      if (initials) {
        portrait = /*#__PURE__*/_react.default.createElement(_portraitInitials.default, {
          size: size,
          shape: shape,
          initials: initials,
          darkBackground: darkBackground,
          alt: alt
        });
      }

      if (src && !this.state.externalError) {
        portrait = /*#__PURE__*/_react.default.createElement(_portrait.StyledCustomImg, {
          src: src,
          alt: alt,
          size: size,
          shape: shape,
          "data-element": "user-image",
          onError: () => this.externalImageLoadFailed()
        });
      }

      if (gravatar && !this.state.externalError) {
        portrait = /*#__PURE__*/_react.default.createElement(_portraitGravatar.default, {
          gravatarEmail: gravatar,
          shape: shape,
          size: size,
          alt: alt,
          errorCallback: () => this.externalImageLoadFailed()
        });
      }

      if (tooltipMessage) {
        return /*#__PURE__*/_react.default.createElement(_tooltip.default, {
          message: tooltipMessage,
          id: tooltipId,
          position: tooltipPosition,
          type: tooltipType,
          size: tooltipSize,
          isVisible: tooltipIsVisible,
          bgColor: tooltipBgColor,
          fontColor: tooltipFontColor
        }, /*#__PURE__*/_react.default.createElement(_portrait.StyledPortraitContainer, _extends({}, this.getMarginProps(), {
          onClick: onClick
        }, tagProps), portrait));
      }

      return /*#__PURE__*/_react.default.createElement(_portrait.StyledPortraitContainer, _extends({}, this.getMarginProps(), {
        onClick: onClick
      }, tagProps), portrait);
    }
  }]);

  return Portrait;
}(_react.default.Component);

Portrait.propTypes = { ...marginPropTypes,

  /** The size of the Portrait. */
  size: _propTypes.default.oneOf(["XS", "S", "M", "ML", "L", "XL", "XXL"]),

  /** A custom image URL. */
  src: props => {
    if (props.src && typeof props.src !== "string") {
      throw new Error(`Invalid prop \`src\` of type \`${typeof props.src}\` supplied to \`Portrait\`, expected \`string\`.`);
    } else if (props.gravatar && props.src) {
      throw new Error('Portrait requires a prop of "src" or "gravatar" but not both');
    }
  },

  /** An email address registered with Gravatar. */
  gravatar: _propTypes.default.string,

  /** The `alt` HTML string. */
  alt: _propTypes.default.string,

  /** The shape of the Portrait. */
  shape: _propTypes.default.oneOf(["circle", "square"]),

  /** The initials to render in the Portrait. */
  initials: _propTypes.default.string,

  /** Use a dark background. */
  darkBackground: _propTypes.default.bool,

  /** The icon to render as fallback */
  iconType: _propTypes.default.string,

  /** Prop for `onClick` events. */
  onClick: _propTypes.default.func,

  /** The message to be displayed within the tooltip */
  tooltipMessage: _propTypes.default.node,

  /** The id attribute to use for the tooltip */
  tooltipId: _propTypes.default.string,

  /** Whether to to show the Tooltip */
  tooltipIsVisible: _propTypes.default.bool,

  /** Sets position of the tooltip */
  tooltipPosition: _propTypes.default.oneOf(["top", "bottom", "left", "right"]),

  /** Defines the message type */
  tooltipType: _propTypes.default.string,

  /** Defines the size of the tooltip content */
  tooltipSize: _propTypes.default.oneOf(["medium", "large"]),

  /** Override background color of the Tooltip, provide any color from palette or any valid css color value. */
  tooltipBgColor: _propTypes.default.string,

  /** Override font color of the Tooltip, provide any color from palette or any valid css color value. */
  tooltipFontColor: _propTypes.default.string
};
Portrait.defaultProps = {
  size: "M",
  shape: "square",
  darkBackground: false,
  alt: "",
  iconType: "individual"
};
var _default = Portrait;
exports.default = _default;